<div class="pdf-viewer-container bg-primary-container">
  <mat-toolbar color="primary">
    <button matIconButton (click)="goBack()" aria-label="Back">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <span class="filename-title">{{ filename() }}</span>
    <span class="spacer"></span>
    @if (!pdfResource.error() && pdfResource.hasValue()) {
      <a matButton [href]="pdfResource.value()!.url" target="_blank" rel="noopener noreferrer" [download]="filename()">
        <mat-icon>download</mat-icon>
        ダウンロード
      </a>
    }
  </mat-toolbar>

  <div class="content-container">
    @if (pdfResource.isLoading()) {
      <div class="loading-container">
        <mat-spinner diameter="48"></mat-spinner>
      </div>
    } @else if (pdfResource.error()) {
      <div class="error-container">
        <p>PDFファイルの読み込みに失敗しました。</p>
      </div>
    } @else if (pdfResource.value(); as pdf) {
      <iframe [src]="pdf.safeUrl" [title]="filename()" width="100%" height="100%" frameborder="0"></iframe>
    }
  </div>
</div>
